import styled from '@emotion/styled'
import { Box, Grid, Stack, Typography } from '@mui/material'


export const CampaignList = styled(Box)(`
    flex-direction: column;
    display: flex;
    border-radius: 8px;
    min-height: 60px;
    position: relative;
    padding: 0 0 0 52px;
    
    & svg {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
    }

    &.type_none {    
        padding: 0 0 0 42px;
        width: 100%;
        border-radius: 0;
        border: 0;
        min-height: 45px;
        & svg {
            left: 2px;
        }
    }
    
    &.type_inline {
        border: 1px #E7E7E6 solid; 
        padding: 15px 15px 15px 52px;
        margin-right: 20px;
    }

    &.type_block {
        border: 1px #E7E7E6 solid;
        padding: 15px 15px 15px 52px;
        width: 100%;
        max-width: 280px;
        margin-bottom:8px;
    }

`)
